import { Navigate, Route, Routes } from "react-router-dom";
import { SiteFooter } from "./components/SiteFooter";
import { SiteHeader } from "./components/SiteHeader";
import { HomePage } from "./pages/HomePage";
import { StudentTranscriptPage } from "./pages/StudentTranscriptPage";
import { OnlineRegistrationPage } from "./pages/OnlineRegistrationPage";
import { API_BASE } from "./apiConfig";
import { useUniversityContent } from "./useUniversityContent";

function App() {
  const uni = useUniversityContent(API_BASE);
  const logoSrc = `${process.env.PUBLIC_URL}/logo-abaarso.png`;
  const heroImageSrc = `${process.env.PUBLIC_URL}/hero-graduation.png`;

  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#main"
        className="absolute left-[-9999px] z-[999] rounded-lg bg-maroon-700 px-4 py-2 text-sm font-medium text-white focus:left-4 focus:top-4 focus:outline-none focus:ring-2 focus:ring-maroon-500 focus:ring-offset-2"
      >
        Skip to content
      </a>

      <SiteHeader uni={uni} logoSrc={logoSrc} />

      <Routes>
        <Route
          path="/"
          element={<HomePage uni={uni} heroImageSrc={heroImageSrc} logoSrc={logoSrc} />}
        />
        <Route path="/about" element={<Navigate to="/#about" replace />} />
        <Route path="/programs" element={<Navigate to="/#programs" replace />} />
        <Route path="/contact" element={<Navigate to="/#contact" replace />} />
        <Route path="/student-results" element={<StudentTranscriptPage />} />
        <Route path="/apply" element={<OnlineRegistrationPage />} />
      </Routes>

      <SiteFooter uni={uni} logoSrc={logoSrc} />
    </div>
  );
}

export default App;
